<template>
  <div class="main-header__lang-switcher">
    <a
      @click="toggleLangShow"
      class="main-header__lang-switcher__text"
      v-if="value === 'en_US'"
    >
      {{ "locale.ro" | trans }}
    </a>
    <a
      @click="toggleLangShow"
      class="main-header__lang-switcher__text"
      v-else-if="value === 'ro_RO'"
    >
      {{ "locale.en" | trans }}
    </a>
    <div
      class="main-header__lang-switcher__dropdown"
      :class="{
        active: activeLangMenu,
      }"
    >
      <div class="navbar-left-languages">
        <span class="navbar-left-languages-icon mr-2">
          <app-languages-icon />
        </span>
        <a
          class="navbar-left-languages-link"
          @click="onChange('ro_RO')"
          href="javascript:"
        >
          RO
        </a>
        <span class="divider-vertical"></span>
        <a
          class="navbar-left-languages-link"
          @click="onChange('en_US')"
          href="javascript:"
        >
          EN
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import AppLanguagesIcon from "@/components/ui/Icons/LanguagesIcon";
export default {
  name: "AppLocaleSwitcher",
  components: {
    AppLanguagesIcon,
  },
  props: {
    value: {
      type: String,
      required: true,
      default: "ro_RO",
    },
    activeLangMenu: {
      type: Boolean,
    },
  },
  methods: {
    onChange(locale) {
      if (this.value === locale) {
        return;
      }

      this.$emit("input", locale);
    },
    onHide() {
      this.$emit("hide");
    },
    toggleLangShow() {
      this.$emit("langShowMenu");
    },
  },
};
</script>

<style lang="scss" scoped>
.active {
  cursor: text;
}
</style>
